import { render } from "./ImageUploadModal.vue?vue&type=template&id=132dac18"
import script from "./ImageUploadModal.vue?vue&type=script&lang=js"
export * from "./ImageUploadModal.vue?vue&type=script&lang=js"

import "./ImageUploadModal.vue?vue&type=style&index=0&id=132dac18&lang=css"

import exportComponent from "/home/ec2-user/environment/links-frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__